import styled from 'styled-components';

export default styled.span`
  color: #0078ff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
